import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import MemberStatusBarChart from '../../Model/Individual/StatisticsModel/MemberStatusBarChart';

import IntroMarkdown from './IntroMarkdown';

// 회원 증감 추이 차트 렌더러 — 통계 MemberStatusBarChart(발산 막대) 재활용. 위=신규+재등록 / 아래=이탈 //
//   색상은 통계 MemberStatusBox.js와 동일(brand500/webBrand500/red) — 다크모드 자동 정합.
export default function MemberFlowTrendRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const { intro, monthlyStats } = data;

  const newColor = theme.brand500;
  const renewalColor = theme.webBrand500;
  const churnColor = isDark ? theme.red600 : theme.red200;

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <LegendWrapper>
        <LegendItem>
          <LegendDot $color={newColor} />
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>
            {t('statistics.memberStatus.tabNew')}
          </Text>
        </LegendItem>
        <LegendItem>
          <LegendDot $color={renewalColor} />
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>
            {t('statistics.memberStatus.tabReRegistered')}
          </Text>
        </LegendItem>
        <LegendItem>
          <LegendDot $color={churnColor} />
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText}>
            {t('statistics.memberStatus.tabChurned')}
          </Text>
        </LegendItem>
      </LegendWrapper>
      <ChartContainer>
        <MemberStatusBarChart
          monthlyStats={monthlyStats}
          newColor={newColor}
          renewalColor={renewalColor}
          churnColor={churnColor}
          scrollBarColor={newColor} />
      </ChartContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 14px;
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LegendDot = styled.div`
  width: 14px;
  height: 14px;

  border-radius: 3px;
  background-color: ${props => props.$color};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;
`;

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  overflow-x: auto;
`;
